import React from 'react'
import { Section } from '../../components/Section'
import { SectionContentHeader } from '../../components/SectionContentHeader'
import { SiteLink } from '../../app-types'
import { INTRASITE_LINKS } from '../../constants'

const links: SiteLink[] = [
  {
    id: 'mara-for-pros-join',
    label: 'Join as a pro',
    variant: 'auto',
    page: null,
    pageSection: null,
    article: null,
    internalHref: INTRASITE_LINKS.professionals.pagePath,
  },
]

export const SectionContentInstanceMaraForPros: React.FunctionComponent =
  () => (
    <Section backgroundColor="white" padding={100}>
      <SectionContentHeader
        id="mara-for-pros"
        align="center"
        subheading={null}
        heading="More shifts. Better matches."
        description={{
          description:
            'Pros love Mara too. With smarter matching, you’ll get more opportunities that fit your skills, preferences, and schedule.',
        }}
        links={links}
        showAppStoreLinks={false}
        eyebrowColor={(theme) => theme.palette.primary.main}
      />
    </Section>
  )
